import { useState, useLayoutEffect } from "react"
import { Row, Col } from "react-bootstrap"
import FilterReport from "../header/FilterReport"
import styles from "../style.module.css"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../../utils/axios.service"
import { Table, Spin, Tabs } from "antd"
import "../scss/report.scss"
import StorageService from "../../../utils/storage.service"

const emptySummary = {
    visited: 0, buyers: 0, close_rate: 0,
    after_net: 0, store_net: 0, paid_after: 0, paid_store: 0,
    aov_card: 0, aov_buyer: 0,
}

const money = (value) => new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND" }).format(value || 0)
const percent = (value) => `${((value || 0) * 100).toFixed(1)}%`

const ReportUpsale = () => {
    const today = format(new Date(), "yyyy-MM-dd")
    const [kind, setKind] = useState("new")
    const [startDate, setStartDate] = useState(format(startOfMonth(new Date()), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(today)
    const [store, setStore] = useState(0)
    const [rows, setRows] = useState([])
    const [details, setDetails] = useState([])
    const [summary, setSummary] = useState(emptySummary)
    const [loading, setLoading] = useState(false)
    const [userAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const isNew = kind === "new"

    const fetchData = async () => {
        setLoading(true)
        const res = await axiosService("api/reports/upsale-customers", "POST", { kind, store, startDate, endDate })
        if (res?.data?.code === 200) {
            setSummary(res.data.data?.summary || emptySummary)
            setRows((res.data.data?.stores || []).map((item) => ({ ...item, key: item.store_id })))
            setDetails((res.data.data?.details || []).map((item) => ({ ...item, key: item.id })))
        } else {
            setSummary(emptySummary)
            setRows([])
            setDetails([])
        }
        setLoading(false)
    }

    useLayoutEffect(() => {
        fetchData()
    }, [startDate, endDate, store, kind])

    const storeColumns = [
        { title: "Cơ sở", dataIndex: "store_name", fixed: "left", width: 180, ellipsis: true },
        { title: "KH qua cơ sở", dataIndex: "visited", align: "center", width: 120 },
        { title: "KH upsale/mua thêm", dataIndex: "buyers", align: "center", width: 150 },
        { title: "Tỷ lệ chốt", dataIndex: "close_rate", align: "center", width: 110, render: percent },
        { title: "DS thuần sau upsale", dataIndex: "after_net", align: "right", width: 160, render: money },
        { title: "DS thuần từ cơ sở", dataIndex: "store_net", align: "right", width: 160, render: money },
        { title: "Thực thu sau upsale", dataIndex: "paid_after", align: "right", width: 160, render: money },
        { title: "Thực thu từ cơ sở", dataIndex: "paid_store", align: "right", width: 160, render: money },
        { title: "AOV thẻ", dataIndex: "aov_card", align: "right", width: 140, render: money },
        { title: "AOV khách", dataIndex: "aov_buyer", align: "right", width: 140, render: money },
    ]
    const detailColumns = [
        { title: "Khách hàng", dataIndex: "full_name", fixed: "left", width: 160, ellipsis: true },
        { title: "SĐT", dataIndex: "mobile", width: 120 },
        { title: "Cơ sở", dataIndex: "store_name", width: 160, ellipsis: true },
        isNew
            ? { title: "Dịch vụ đăng ký Online", dataIndex: "online_cards", width: 240, ellipsis: true }
            : { title: "Thẻ đang sở hữu", dataIndex: "owned_cards", width: 220, ellipsis: true },
        isNew
            ? { title: "Thẻ mua tại cơ sở", dataIndex: "store_cards", width: 220, ellipsis: true }
            : { title: "Thẻ mua thêm Online", dataIndex: "online_cards", width: 220, ellipsis: true },
        !isNew && { title: "Phân loại", dataIndex: "purchase_type", width: 160 },
        { title: "DS sau upsale", dataIndex: "after_net", align: "right", width: 140, render: money },
        { title: "DS từ cơ sở", dataIndex: "store_net", align: "right", width: 140, render: money },
        { title: "Thực thu sau", dataIndex: "paid_after", align: "right", width: 140, render: money },
        { title: "Thực thu từ cơ sở", dataIndex: "paid_store", align: "right", width: 150, render: money },
    ].filter(Boolean)

    const metrics = [
        ["KH qua cơ sở", summary.visited],
        ["KH upsale/mua thêm", summary.buyers],
        ["Tỷ lệ chốt", percent(summary.close_rate)],
        ["DS thuần sau upsale", money(summary.after_net)],
        ["DS thuần từ cơ sở", money(summary.store_net)],
        ["Thực thu sau upsale", money(summary.paid_after)],
        ["Thực thu từ cơ sở", money(summary.paid_store)],
        ["AOV thẻ", money(summary.aov_card)],
        ["AOV khách", money(summary.aov_buyer)],
    ]

    return (
        <div className={`${styles.background} container-fluid report-page course-customer-report`}>
            <FilterReport
                startDate={startDate}
                endDate={endDate}
                handleRangeDate={(sDate, eDate) => {
                    setStartDate(sDate)
                    setEndDate(eDate)
                }}
                store={store}
                handleStore={setStore}
                title="Báo cáo Upsale / Mua thêm"
                type="upsale"
                userAdmin={userAdmin}
            />
            <Tabs activeKey={kind} onChange={setKind}>
                <Tabs.TabPane tab="Khách mới từ Online" key="new" />
                <Tabs.TabPane tab="Khách liệu trình từ Online" key="course" />
            </Tabs>
            <Spin spinning={loading}>
                <Row className="mb-3">
                    {metrics.map(([label, value], index) => (
                        <Col key={label} xs={6} md={4} lg={2} className="mb-2">
                            <div className={`course-kpi${index === 0 ? " is-primary" : ""}`}>
                                <div className="course-kpi-label">{label}</div>
                                <strong>{value}</strong>
                            </div>
                        </Col>
                    ))}
                </Row>
                <div className="course-panel">
                    <Table
                        className="course-grid"
                        columns={storeColumns}
                        dataSource={rows}
                        pagination={false}
                        bordered
                        tableLayout="fixed"
                        scroll={{ x: 1580 }}
                        locale={{ emptyText: "Không có dữ liệu trong bộ lọc này" }}
                    />
                </div>
                <div className="bg-white mt-3 card-service-matrix">
                    <div style={{ padding: "14px 16px 8px", fontSize: 16, fontWeight: 700 }}>
                        {isNew ? "Đăng ký Online và thẻ mua tại buổi đến cơ sở" : "Thẻ đang có và thẻ mua thêm từ Online"}
                    </div>
                    <div className="px-2 pb-2">
                        <Table
                            columns={detailColumns}
                            dataSource={details}
                            size="small"
                            bordered
                            scroll={{ x: 1500, y: 480 }}
                            pagination={{ pageSize: 20, showSizeChanger: false }}
                            locale={{ emptyText: "Không có đơn upsale trong bộ lọc này" }}
                        />
                    </div>
                </div>
            </Spin>
        </div>
    )
}

export default ReportUpsale
